export const labelsGaNames = {
  PIM: 'onlineOnly',
  BPR: 'bestPrice',
  LOF: 'offerLimited',
  STD: 'discount',
} as const;

export function getProductBelongFromSource(productSource: string | undefined) {
  let productBelong: 'LM' | 'LMMarket' = 'LM';
  if (productSource?.toLowerCase() === 'pim') {
    productBelong = 'LMMarket';
  }
  return productBelong;
}

export function calculateDiscount(previousPrice: number | null | undefined, mainPrice: number) {
  if (!previousPrice || previousPrice <= mainPrice) {
    return null;
  }

  const discountAmount = previousPrice - mainPrice;
  const decimalDiscount = discountAmount / previousPrice;

  return parseFloat(decimalDiscount.toFixed(2));
}
